/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { $el, bind, getBooleanTypeAttr, getNumTypeAttr, getStrTypeAttr, removeAttrs, setHtml } from '../../dom-utils';
import { warn } from '../../mixins';
import { type, validComps } from '../../utils';
import PREFIX from '../prefix';
function addNum(num1, num2) {
    var sq1, sq2;
    try {
        sq1 = num1.toString().split('.')[1].length;
    }
    catch (e) {
        sq1 = 0;
    }
    try {
        sq2 = num2.toString().split('.')[1].length;
    }
    catch (e) {
        sq2 = 0;
    }
    var m = Math.pow(10, Math.max(sq1, sq2));
    return (Math.round(num1 * m) + Math.round(num2 * m)) / m;
}
var InputNumber = /** @class */ (function () {
    function InputNumber() {
        this.VERSION = 'v1.0';
        this.COMPONENTS = $el('r-input-number', { all: true });
        this._create(this.COMPONENTS);
    }
    InputNumber.prototype.config = function (el) {
        var target = $el(el);
        validComps(target, 'input-number');
        var _a = InputNumber.prototype, _attrs = _a._attrs, _setValue = _a._setValue, _setDisabled = _a._setDisabled;
        var _b = _attrs(target), min = _b.min, max = _b.max, step = _b.step, disabled = _b.disabled, readOnly = _b.readOnly, editable = _b.editable, precision = _b.precision, formatter = _b.formatter;
        var Input = target.querySelector("." + PREFIX.inputnb + "-input");
        var ArrowUp = target.querySelector("." + PREFIX.inputnb + "-handler-up");
        var ArrowDown = target.querySelector("." + PREFIX.inputnb + "-handler-down");
        var BtnUp = target.querySelector("." + PREFIX.inputnb + "-controls-outside-up");
        var BtnDown = target.querySelector("." + PREFIX.inputnb + "-controls-outside-down");
        return {
            get value() {
                return Number(Input.value);
            },
            set value(newVal) {
                if (newVal && !type.isNum(newVal))
                    return;
                _setValue(Input, newVal, formatter, precision, min, max);
            },
            get step() {
                return step;
            },
            set step(newVal) {
                if (newVal && !type.isNum(newVal))
                    return;
                Input.step = step;
            },
            get disabled() {
                return disabled;
            },
            set disabled(newVal) {
                if (newVal && !type.isBol(newVal))
                    return;
                _setDisabled(target, Input, newVal);
            },
            get readOnly() {
                return readOnly;
            },
            set readOnly(newVal) {
                if (newVal && !type.isBol(newVal))
                    return;
                Input.readOnly = newVal;
                var disableArrow = function (elem1, elem2) {
                    if (elem1) {
                        // @ts-ignore
                        elem1.style.pointerEvents = newVal ? 'none' : '';
                        // @ts-ignore
                        elem2.style.pointerEvents = newVal ? 'none' : '';
                    }
                };
                disableArrow(ArrowUp, ArrowDown);
                disableArrow(BtnUp, BtnDown);
            },
            get editable() {
                return editable;
            },
            set editable(newVal) {
                if (newVal && !type.isBol(newVal))
                    return;
                Input.style.pointerEvents = !newVal ? 'none' : '';
            },
            events: function (_a) {
                var onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur;
                var value;
                var changeEv = function (e) {
                    e.stopPropagation();
                    value = Number(Input.value);
                    if (!isNaN(value)) {
                        onChange && type.isFn(onChange, value);
                    }
                    else {
                        warn("Invalid input value --> '" + Input.value + "' at '" + el + "'");
                        return;
                    }
                };
                if (ArrowUp) {
                    bind(ArrowUp, 'click', changeEv);
                    bind(ArrowDown, 'click', changeEv);
                }
                if (BtnUp) {
                    bind(BtnUp, 'click', changeEv);
                    bind(BtnDown, 'click', changeEv);
                }
                bind(Input, 'keydown', function (e) {
                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown')
                        changeEv(e);
                });
                bind(Input, 'input', function (e) { return changeEv(e); });
                bind(Input, 'focus', function (e) {
                    e.stopPropagation();
                    onFocus && type.isFn(onFocus, e);
                });
                bind(Input, 'blur', function (e) {
                    e.stopPropagation();
                    onBlur && type.isFn(onBlur);
                });
            }
        };
    };
    InputNumber.prototype._create = function (COMPONENTS) {
        var _this = this;
        COMPONENTS.forEach(function (node) {
            var _a = _this._attrs(node), min = _a.min, max = _a.max, step = _a.step, value = _a.value, name = _a.name, inputId = _a.inputId, parser = _a.parser, formatter = _a.formatter, precision = _a.precision, disabled = _a.disabled, editable = _a.editable, readOnly = _a.readOnly, size = _a.size, placeholder = _a.placeholder, controlsOutside = _a.controlsOutside;
            _this._setMainTemplate(node);
            _this._setOutSide(node, controlsOutside);
            var Input = node.querySelector("." + PREFIX.inputnb + "-input");
            var ArrowUp = node.querySelector("." + PREFIX.inputnb + "-handler-up");
            var ArrowDown = node.querySelector("." + PREFIX.inputnb + "-handler-down");
            var BtnUp = node.querySelector("." + PREFIX.inputnb + "-controls-outside-up");
            var BtnDown = node.querySelector("." + PREFIX.inputnb + "-controls-outside-down");
            _this._setInput(Input, min, max, step, name, inputId, placeholder);
            _this._setValue(Input, value, formatter, precision, min, max);
            _this._setSize(node, size);
            _this._setDisabled(node, Input, disabled);
            _this._setReadonlyAndEditable(Input, readOnly, editable);
            _this._setHandler(ArrowUp, ArrowDown, BtnUp, BtnDown, value, min, max);
            _this._handleChange(Input, ArrowUp, ArrowDown, BtnUp, BtnDown, min, max, step, precision, readOnly, parser, formatter);
            removeAttrs(node, [
                'min',
                'max',
                'step',
                'value',
                'precision',
                'size',
                'name',
                'parser',
                'formatter',
                'input-id',
                'placeholder',
                'disabled',
                'editable',
                'readOnly',
                'controls-outside'
            ]);
        });
    };
    InputNumber.prototype._setMainTemplate = function (node) {
        node.classList.add("" + PREFIX.inputnb);
        var template = "\n        <div class=\"" + PREFIX.inputnb + "-handler-wrap\">\n            <a class=\"" + PREFIX.inputnb + "-handler " + PREFIX.inputnb + "-handler-up\">\n                <span class=\"" + PREFIX.inputnb + "-handler-up-inner " + PREFIX.icon + " " + PREFIX.icon + "-ios-arrow-up\"></span>\n            </a>\n            <a class=\"" + PREFIX.inputnb + "-handler " + PREFIX.inputnb + "-handler-down\">\n                <span class=\"" + PREFIX.inputnb + "-handler-down-inner " + PREFIX.icon + " " + PREFIX.icon + "-ios-arrow-down\"></span>\n            </a>\n        </div>\n        <div class=\"" + PREFIX.inputnb + "-input-wrap\">\n           <input autocomplete=\"off\" spellcheck=\"false\" class=\"" + PREFIX.inputnb + "-input\">\n        </div>\n        ";
        setHtml(node, template);
    };
    InputNumber.prototype._setOutSide = function (node, controlsOutside) {
        if (!controlsOutside)
            return;
        node.classList.add(PREFIX.inputnb + "-controls-outside");
        var handlerWrap = node.querySelector("." + PREFIX.inputnb + "-handler-wrap");
        var template = "\n         <div class=\"" + PREFIX.inputnb + "-controls-outside-btn " + PREFIX.inputnb + "-controls-outside-down\">\n            <i class=\"" + PREFIX.icon + " " + PREFIX.icon + "-ios-remove\"></i>\n         </div>\n         <div class=\"" + PREFIX.inputnb + "-controls-outside-btn " + PREFIX.inputnb + "-controls-outside-up\">\n            <i class=\"" + PREFIX.icon + " " + PREFIX.icon + "-ios-add\"></i>\n         </div>\n        ";
        handlerWrap.insertAdjacentHTML('afterend', template);
        handlerWrap.remove();
    };
    InputNumber.prototype._setInput = function (input, min, max, step, name, inputId, placeholder) {
        isNaN(min) || min === 0 ? (input.min = "" + min) : '';
        isNaN(max) || min === 0 ? (input.max = "" + max) : '';
        isNaN(step) && step !== 1 ? (input.step = "" + step) : '';
        name ? (input.name = name) : '';
        inputId ? (input.id = inputId) : '';
        placeholder ? (input.placeholder = placeholder) : '';
    };
    InputNumber.prototype._formatterVal = function (input, formatter, val) {
        // `约定的 ${value}`替换为 `${val}`
        var resVal = formatter.replace('value', 'val');
        input.value = "" + (formatter ? eval(resVal) : val);
    };
    InputNumber.prototype._parserVal = function (parser, val) {
        if (parser) {
            var _parser = eval(parser);
            return val.replace(_parser[0], _parser[1]);
        }
        else {
            // 如果没有指定从 formatter 里转换回数字的方式，则使用默认正则方式
            return val.replace(/[^\d.-]/g, '');
        }
    };
    InputNumber.prototype._handleChange = function (input, aUp, aDown, btnUp, btnDown, min, max, step, precision, readOnly, parser, formatter) {
        var _this = this;
        if (readOnly)
            return;
        var setValue = function (val) {
            _this._setValue(input, val, formatter, precision, min, max);
            _this._setHandler(aUp, aDown, btnUp, btnDown, val, min, max);
        };
        var changeStep = function (type) {
            // 如果指定了输入框展示值的格式，那么这里就要用 parser 的值转换为原来的值
            var val = _this._parserVal(parser, input.value);
            var targetVal = Number(val);
            if (type === 'up') {
                if (addNum(targetVal, step) <= max) {
                    setValue(targetVal);
                }
                else {
                    return false;
                }
                setValue(addNum(targetVal, step));
            }
            else if (type === 'down') {
                if (addNum(targetVal, step) >= min) {
                    setValue(targetVal);
                }
                else {
                    return false;
                }
                setValue(addNum(targetVal, -step));
            }
        };
        var handleKeyBoardChange = function () {
            bind(input, 'keydown', function (e) {
                if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown')
                    return false;
                if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    changeStep('up');
                }
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    changeStep('down');
                }
            });
        };
        var handleInputChange = function () {
            bind(input, 'input', function (e) {
                e.stopPropagation();
                // 当输入框输入时只匹配数字、小数点和减号
                var val = input.value.replace(/[^\d.-]/g, '');
                setValue(Number(val));
            });
        };
        var handleArrowChange = function () {
            if (aUp && aDown) {
                bind(aUp, 'click', function () { return changeStep('up'); });
                bind(aDown, 'click', function () { return changeStep('down'); });
            }
            if (btnUp && btnDown) {
                bind(btnUp, 'click', function () { return changeStep('up'); });
                bind(btnDown, 'click', function () { return changeStep('down'); });
            }
        };
        handleKeyBoardChange();
        handleInputChange();
        handleArrowChange();
    };
    InputNumber.prototype._setValue = function (input, value, formatter, precision, min, max) {
        var targetVal = !isNaN(precision) ? value.toFixed(precision) : value;
        if ((targetVal && !isNaN(targetVal)) || targetVal === 0) {
            if (targetVal > max && !isNaN(max)) {
                targetVal = max;
            }
            else if (targetVal < min && !isNaN(min)) {
                targetVal = min;
            }
            // 如果指定了输入框展示值的格式则使用它，否则反之
            this._formatterVal(input, formatter, targetVal);
        }
    };
    InputNumber.prototype._setSize = function (node, size) {
        if (!size)
            return;
        node.classList.add(PREFIX.inputnb + "-" + size);
    };
    InputNumber.prototype._setReadonlyAndEditable = function (input, readOnly, editable) {
        if (readOnly)
            input.readOnly = true;
        if (readOnly || editable === 'false')
            input.style.pointerEvents = 'none';
    };
    InputNumber.prototype._setDisabled = function (node, input, disabled) {
        if (!disabled) {
            node.classList.remove(PREFIX.inputnb + "-disabled");
            input.disabled = false;
        }
        else {
            node.classList.add(PREFIX.inputnb + "-disabled");
            input.disabled = true;
        }
    };
    InputNumber.prototype._setHandler = function (aUp, aDown, btnUp, btnDown, value, min, max) {
        var isSetDisable = function (elm1, elm2, outside) {
            var upDisabledCls = outside ? 'controls-outside-btn' : 'handler-up';
            var downDisabledCls = outside ? 'controls-outside-btn' : 'handler-down';
            if (Math.ceil(value) >= max) {
                elm1.classList.add(PREFIX.inputnb + "-" + upDisabledCls + "-disabled");
            }
            else {
                elm1.classList.remove(PREFIX.inputnb + "-" + upDisabledCls + "-disabled");
            }
            if (Math.ceil(value) <= min) {
                elm2.classList.add(PREFIX.inputnb + "-" + downDisabledCls + "-disabled");
            }
            else {
                elm2.classList.remove(PREFIX.inputnb + "-" + downDisabledCls + "-disabled");
            }
        };
        if (aUp && aDown)
            isSetDisable(aUp, aDown, false);
        if (btnUp && btnDown)
            isSetDisable(btnUp, btnDown, true);
    };
    InputNumber.prototype._attrs = function (node) {
        return {
            min: getNumTypeAttr(node, 'min', -Infinity),
            max: getNumTypeAttr(node, 'max', Infinity),
            step: getNumTypeAttr(node, 'step', 1),
            value: getNumTypeAttr(node, 'value', 0),
            precision: getNumTypeAttr(node, 'precision'),
            size: getStrTypeAttr(node, 'size', ''),
            name: getStrTypeAttr(node, 'name', ''),
            inputId: getStrTypeAttr(node, 'input-id', ''),
            parser: getStrTypeAttr(node, 'parser', ''),
            formatter: getStrTypeAttr(node, 'formatter', ''),
            placeholder: getStrTypeAttr(node, 'placeholder', ''),
            disabled: getBooleanTypeAttr(node, 'disabled'),
            readOnly: getBooleanTypeAttr(node, 'readonly'),
            editable: getStrTypeAttr(node, 'editable', 'true'),
            controlsOutside: getBooleanTypeAttr(node, 'controls-outside')
        };
    };
    return InputNumber;
}());
export default InputNumber;
